import { IconButton, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import { AMS_TAB_LABEL } from "./AmsTabs/hashFunctions";
import {
  AMS_TAB_TITLE_MAINTENANCE,
  AMS_TAB_TITLE_REALTIME,
  AMS_TAB_TITLE_SMART_PID,
} from "./AmsTabs/ApsTabsConfig";
import SchemaIcon from "@mui/icons-material/Schema";
import ViewInArIcon from "@mui/icons-material/ViewInAr";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";

function amsTabHref(plantId, tabTitle) {
  const params = new URLSearchParams();
  params.set(AMS_TAB_LABEL, tabTitle);
  return `/ams/${plantId}#${params.toString()}`;
}

const tabHeadSx = {
  width: "100%",
  minWidth: 0,

  whiteSpace: "normal",
  overflowWrap: "anywhere",
  wordBreak: "break-word",

  textAlign: "center",
  verticalAlign: "middle",

  lineHeight: 1.05,

  px: {
    xs: 0,
    sm: 0.15,
    md: 0.4,
  },

  py: {
    xs: 0.25,
    md: 0.75,
  },
};

const tabBodySx = {
  minWidth: 0,

  textAlign: "center",
  verticalAlign: "middle",

  px: {
    xs: 0,
    sm: 0.15,
    md: 0.4,
  },

  "& .Mui-TableBodyCell-Content-Wrapper": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    width: "100%",
    minWidth: 0,

    overflow: "hidden",
  },
};

/** @type {import('material-react-table').MRT_ColumnDef<any>[]} */
export const amsPlantListColumns = [
  {
    accessorKey: "name",
    header: "Plant Name",
    size: 220,
    enableColumnFilter: true,
  },
  {
    accessorKey: "clientName",
    header: "Client",
    size: 120,
    filterVariant: "select",
    enableColumnFilter: true,
  },
  {
    accessorKey: "people",
    header: "People",
    size: 200,
    enableColumnFilter: false,
    Cell: ({ cell }) => {
      const people = cell.getValue();
      if (!people || !Array.isArray(people) || people.length === 0) {
        return <span>-</span>;
      }
      return (
        <span>
          {people
            .map((u) => (typeof u === "object" ? u.name || u.email : u))
            .join(", ")}
        </span>
      );
    },
  },
  {
    accessorKey: "projects",
    header: "No. sub projects",
    size: 100,
    enableColumnFilter: false,
    Cell: ({ row }) => {
      const plant = row.original;
      const projects = plant.projects || plant.project;

      if (!projects) {
        return <span>0</span>;
      }

      const projectsArray = Array.isArray(projects)
        ? projects
        : projects
          ? [projects]
          : [];

      const clientName = process.env.REACT_APP_CLIENT_NAME;
      const filteredProjects = projectsArray.filter(
        (p) => p && p.clientName === clientName,
      );

      return <span>{filteredProjects.length}</span>;
    },
  },
  {
    accessorKey: "ditIntelligentPlantData",
    header: AMS_TAB_TITLE_SMART_PID,
    size: 72,
    enableColumnFilter: false,
    enableColumnActions: false,
    muiTableHeadCellProps: {
      sx: tabHeadSx,
    },

    muiTableBodyCellProps: {
      sx: tabBodySx,
    },
    Cell: ({ row }) => (
      <Tooltip title={`Open ${AMS_TAB_TITLE_SMART_PID}`}>
        <IconButton
          component={Link}
          to={amsTabHref(row.original.id, AMS_TAB_TITLE_SMART_PID)}
          onClick={(e) => e.stopPropagation()}
        >
          <SchemaIcon fontSize="medium" color="primary" />
        </IconButton>
      </Tooltip>
    ),
  },
  {
    accessorKey: "realtimePlantData",
    header: AMS_TAB_TITLE_REALTIME,
    size: 72,
    enableColumnFilter: false,
    enableColumnActions: false,
    muiTableHeadCellProps: {
      sx: tabHeadSx,
    },

    muiTableBodyCellProps: {
      sx: tabBodySx,
    },
    Cell: ({ row }) => (
      <Tooltip title={`Open ${AMS_TAB_TITLE_REALTIME}`}>
        <IconButton
          component={Link}
          to={amsTabHref(row.original.id, AMS_TAB_TITLE_REALTIME)}
          onClick={(e) => e.stopPropagation()}
        >
          <ViewInArIcon fontSize="medium" color="primary" />
        </IconButton>
      </Tooltip>
    ),
  },
  {
    accessorKey: "ditMaintenanceSystem",
    header: AMS_TAB_TITLE_MAINTENANCE,
    size: 72,
    enableColumnFilter: false,
    enableColumnActions: false,
    muiTableHeadCellProps: {
      sx: tabHeadSx,
    },

    muiTableBodyCellProps: {
      sx: tabBodySx,
    },
    Cell: ({ row }) => (
      <Tooltip title={`Open ${AMS_TAB_TITLE_MAINTENANCE}`}>
        <IconButton
          component={Link}
          to={amsTabHref(row.original.id, AMS_TAB_TITLE_MAINTENANCE)}
          onClick={(e) => e.stopPropagation()}
        >
          <SettingsApplicationsIcon fontSize="medium" color="primary" />
        </IconButton>
      </Tooltip>
    ),
  },
];
